export const buildChangedPayload = ({ data, defaultValues, editableFields }) =>
  editableFields.reduce((payload, field) => {
    const nextValue = data[field] ?? null;
    const previousValue = defaultValues[field] ?? null;

    if (nextValue !== previousValue) {
      return {
        ...payload,
        [field]: nextValue,
      };
    }

    return payload;
  }, {});

export const buildIssueDetailUpdatePayload = ({
  data,
  defaultValues,
  editableFields,
  recordVersion,
}) => ({
  ...buildChangedPayload({ data, defaultValues, editableFields }),
  recordVersion,
});
